<swiper-container
*ngIf="homeBanners"
#bannerSlide
appSwiper
id="banner-slider"
init="false"
[config]="this.config"
class="swiper-wrapper swiper-container">
  <swiper-slide  class="homebanner-slide swiper-slide">
    <a class="banner-link" href="{{bannerHref[0]}}">
      <img fetchpriority="high"  src="{{bannersUrls[0]}}" alt="Home page banners">
    </a>
   </swiper-slide>
  <swiper-slide  class="homebanner-slide swiper-slide">
    <a class="banner-link" href="{{bannerHref[1]}}">
      <img src="{{bannersUrls[1]}}" alt="Home page banners" fetchpriority="high" >
    </a>
   </swiper-slide>
  <swiper-slide  class="homebanner-slide swiper-slide">
     <a class="banner-link" href="{{bannerHref[2]}}">
    <img src="{{bannersUrls[2]}}" alt="Home page banners" fetchpriority="high" ></a>
   </swiper-slide>
  <swiper-slide  class="homebanner-slide swiper-slide">
     <a class="banner-link" href="{{bannerHref[3]}}">
    <img src="{{bannersUrls[3]}}" alt="Home page banners" fetchpriority="high" ></a>
   </swiper-slide>
  <swiper-slide  class="homebanner-slide swiper-slide">
     <a class="banner-link" href="{{bannerHref[4]}}">
    <img src="{{bannersUrls[4]}}" alt="Home page banners" fetchpriority="high" ></a>
   </swiper-slide>
  <swiper-slide  class="homebanner-slide swiper-slide">
     <a class="banner-link" href="{{bannerHref[5]}}">
    <img src="{{bannersUrls[5]}}" alt="Home page banners" fetchpriority="high" ></a>
   </swiper-slide>
  <swiper-slide  class="homebanner-slide swiper-slide">
     <a class="banner-link" href="{{bannerHref[6]}}">
    <img src="{{bannersUrls[6]}}" alt="Home page banners" fetchpriority="high" ></a>
   </swiper-slide>
  <swiper-slide  class="homebanner-slide swiper-slide">
     <a class="banner-link" href="{{bannerHref[7]}}">
    <img src="{{bannersUrls[7]}}" alt="Home page banners" fetchpriority="high" ></a>
   </swiper-slide>
  <swiper-slide  class="homebanner-slide swiper-slide">
     <a class="banner-link" href="{{bannerHref[8]}}">
    <img src="{{bannersUrls[8]}}" alt="Home page banners" fetchpriority="high" ></a>
   </swiper-slide>
  <swiper-slide  class="homebanner-slide swiper-slide">
     <a class="banner-link" href="{{bannerHref[9]}}">
    <img src="{{bannersUrls[9]}}" alt="Home page banners" fetchpriority="high" ></a>
   </swiper-slide>
  <swiper-slide  class="homebanner-slide swiper-slide">
     <a class="banner-link" href="{{bannerHref[10]}}">
    <img src="{{bannersUrls[10]}}" alt="Home page banners" fetchpriority="high" ></a>
   </swiper-slide>
  <swiper-slide  class="homebanner-slide swiper-slide">
     <a class="banner-link" href="{{bannerHref[11]}}">
    <img src="{{bannersUrls[11]}}" alt="Home page banners" fetchpriority="high" ></a>
   </swiper-slide>
  <swiper-slide  class="homebanner-slide swiper-slide">
    <a class="banner-link" href="{{bannerHref[0]}}">
      <img fetchpriority="high"  src="{{bannersUrls[0]}}" alt="Home page banners">
    </a>
   </swiper-slide>
  <swiper-slide  class="homebanner-slide swiper-slide">
    <a class="banner-link" href="{{bannerHref[1]}}">
      <img src="{{bannersUrls[1]}}" alt="Home page banners" fetchpriority="high" >
    </a>
   </swiper-slide>
  <swiper-slide  class="homebanner-slide swiper-slide">
     <a class="banner-link" href="{{bannerHref[2]}}">
    <img src="{{bannersUrls[2]}}" alt="Home page banners" fetchpriority="high" ></a>
   </swiper-slide>
  <swiper-slide  class="homebanner-slide swiper-slide">
     <a class="banner-link" href="{{bannerHref[3]}}">
    <img src="{{bannersUrls[3]}}" alt="Home page banners" fetchpriority="high" ></a>
   </swiper-slide>
  <swiper-slide  class="homebanner-slide swiper-slide">
     <a class="banner-link" href="{{bannerHref[4]}}">
    <img src="{{bannersUrls[4]}}" alt="Home page banners" fetchpriority="high" ></a>
   </swiper-slide>
  <swiper-slide  class="homebanner-slide swiper-slide">
     <a class="banner-link" href="{{bannerHref[5]}}">
    <img src="{{bannersUrls[5]}}" alt="Home page banners" fetchpriority="high" ></a>
   </swiper-slide>
  <swiper-slide  class="homebanner-slide swiper-slide">
     <a class="banner-link" href="{{bannerHref[6]}}">
    <img src="{{bannersUrls[6]}}" alt="Home page banners" fetchpriority="high" ></a>
   </swiper-slide>
  <swiper-slide  class="homebanner-slide swiper-slide">
     <a class="banner-link" href="{{bannerHref[7]}}">
    <img src="{{bannersUrls[7]}}" alt="Home page banners" fetchpriority="high" ></a>
   </swiper-slide>
  <swiper-slide  class="homebanner-slide swiper-slide">
     <a class="banner-link" href="{{bannerHref[8]}}">
    <img src="{{bannersUrls[8]}}" alt="Home page banners" fetchpriority="high" ></a>
   </swiper-slide>
  <swiper-slide  class="homebanner-slide swiper-slide">
     <a class="banner-link" href="{{bannerHref[9]}}">
    <img src="{{bannersUrls[9]}}" alt="Home page banners" fetchpriority="high" ></a>
   </swiper-slide>
  <swiper-slide  class="homebanner-slide swiper-slide">
     <a class="banner-link" href="{{bannerHref[10]}}">
    <img src="{{bannersUrls[10]}}" alt="Home page banners" fetchpriority="high" ></a>
   </swiper-slide>
  <swiper-slide  class="homebanner-slide swiper-slide">
     <a class="banner-link" href="{{bannerHref[11]}}">
    <img src="{{bannersUrls[11]}}" alt="Home page banners" fetchpriority="high" ></a>
   </swiper-slide>
</swiper-container>
